export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10450.0265eca4.jpg";